import { withPrefix } from "gatsby"

export const withLink = function withLink(path) {
    if (typeof process !== 'undefined' && process.env.GATSBY_LINK_PREFIX) {
        return `${process.env.GATSBY_LINK_PREFIX}${path}`
    }
    return withPrefix(path)
}